var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenticoLogoHorColorPosSzRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 554.49 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f05a22;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.13,127.45l19.73,25.31H275l-16.5-22.16v22.16H246.85V102.55h11.62v22.3L275,102.55h13.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M324.82,138.49H299.29c.2,4.55,3.22,7,8.1,7,3.37,0,5.52-.91,6.45-3.09h10.75c-1.08,6.81-8,11.33-17.22,11.33-11.77,0-19-6.67-19-18.18,0-11.33,7.39-18.18,18.65-18.18,10.76,0,18.08,6.67,18.08,16.42a39.41,39.41,0,0,1-.27,4.74Zm-10.54-6.82c-.08-4.54-2.66-7-7.32-7s-7.6,2.8-7.67,7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.42,118.19h11v5c2-3.87,6-6,11.2-6,8.39,0,12.62,4.73,12.62,14.12v21.39h-11V135c0-5.81-1.65-8.46-6.09-8.46s-6.68,2.87-6.68,8.18V152.8h-11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.27,144v8.75a43.8,43.8,0,0,1-7.32.58c-5.16,0-12.26-1.15-12.26-12.73V126.86h-5.46v-8.67h5.46V107.93h11v10.26h7.83v8.67h-7.81v11.49c0,5.09,2.08,5.88,4.8,5.88A32.11,32.11,0,0,0,396.27,144Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.29,108.5a6.66,6.66,0,0,1,1.09-3.8,6.83,6.83,0,1,1-.6,6.38,6.51,6.51,0,0,1-.49-2.58Zm1.29,9.69h10.91v34.55H402.58Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M419.87,135.47c0-10.91,7.1-18.18,18.5-18.18,10.32,0,17.07,5.46,17.93,14.06h-11c-.79-3.22-2.87-4.73-6.89-4.73-4.74,0-7.6,3.15-7.6,8.89s2.86,8.9,7.6,8.9c4,0,6.1-1.44,6.89-4.46h11c-.86,8.4-7.61,13.78-17.93,13.78C427,153.69,419.87,146.37,419.87,135.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M461.1,135.47c0-10.54,7.32-18.18,19.23-18.18s19.16,7.67,19.16,18.18-7.32,18.18-19.16,18.18S461.1,146,461.1,135.47Zm27.48,0c0-5.23-3.09-9-8.25-9s-8.24,3.73-8.24,9,3,9,8.24,9S488.58,140.71,488.58,135.47Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 130.03,
    cy: 130,
    r: 75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130,120a10.06,10.06,0,0,1,9.29,6.21,10,10,0,0,1-13.13,13.13A10.05,10.05,0,0,1,130,120"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.85,123.1h21.6a.84.84,0,0,1,.53.19.77.77,0,0,1,.28.48c.53,2.72,1.92,13.13-6.84,13.13H156c-8.5,0-8.69-13.8-.1-13.8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.21,136.9H82.61a.86.86,0,0,1-.53-.19.87.87,0,0,1-.28-.48c-.53-2.72-1.91-13.13,6.84-13.13h15.47c8.5,0,8.69,13.8.1,13.8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.41,106.86l15.28-15.28a.86.86,0,0,1,.5-.23.78.78,0,0,1,.54.14c2.32,1.57,10.64,7.92,4.44,14.12l-10.93,10.93c-6,6-15.9-3.63-9.83-9.68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.65,153.14l-15.28,15.27a.79.79,0,0,1-.5.24.8.8,0,0,1-.54-.14c-2.32-1.58-10.64-7.93-4.44-14.12l10.93-10.94C112.84,137.44,122.72,147.08,116.65,153.14Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.13,104.18V82.57a.83.83,0,0,1,.19-.52.77.77,0,0,1,.48-.28c2.72-.52,13.13-1.92,13.13,6.85V104c0,8.5-13.8,8.69-13.8.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.93,155.82v21.61a.83.83,0,0,1-.19.52.87.87,0,0,1-.48.28c-2.72.52-13.13,1.91-13.13-6.85V155.91C123.13,147.42,136.93,147.22,136.93,155.82Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.9,116.62,91.62,101.34a.81.81,0,0,1-.24-.5.8.8,0,0,1,.14-.54c1.58-2.32,7.93-10.63,14.13-4.44l10.93,10.94c6,6-3.63,15.9-9.68,9.82"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.16,143.38l15.28,15.27a.84.84,0,0,1,.24.51.8.8,0,0,1-.14.54c-1.58,2.32-7.93,10.63-14.12,4.44L143.48,153.2c-6-6,3.63-15.9,9.68-9.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenticoLogoHorColorPosSzRgb);
export default __webpack_public_path__ + "static/media/kentico-logo-hor-color-pos-sz-rgb.f57a9042bcf39a5bd47419a05036051d.svg";
export { ForwardRef as ReactComponent };